import React from 'react';
import { captureError } from '../utils/errorReporting';

// Top-level render guard: a crashed route renders this fallback instead of a
// blank page, and the error is funneled to errorReporting (console + buffer
// + optional endpoint). Pattern follows the react_freekwent ErrorBoundary.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    captureError(error, {
      source: 'ErrorBoundary',
      componentStack: info?.componentStack || null,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
          <h2>Something went wrong</h2>
          <p>
            This page hit an unexpected error. The error has been recorded in
            the browser console. Reloading usually recovers the session.
          </p>
          <button type="button" onClick={this.handleReload}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
